import { useCallback, useEffect, useRef } from 'react';
export default function useTimeoutFn(fn, ms = null) {
  const ready = useRef(false);
  const timeout = useRef(undefined);
  const callback = useRef(fn);
  const isReady = useCallback(() => ready.current, []);
  const set = useCallback(() => {
    if (ms === null) return;
    ready.current = false;
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      ready.current = true;
      callback.current();
    }, ms);
  }, [ms]);
  const cancel = useCallback(() => {
    ready.current = null;
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
  }, []);
  useEffect(() => {
    callback.current = fn;
  }, [fn]);
  useEffect(() => {
    if (ms !== null) {
      set();
    }
    return cancel;
  }, [cancel, ms, set]);
  return {
    isReady,
    cancel
  };
}